import { Component, OnInit } from '@angular/core';
import { IMAGE_GRID } from 'src/app/data/warehouse/image-grid.data';

@Component({
  selector: 'app-warehouse-page',
  templateUrl: './warehouse-page.component.html',
  styleUrls: ['./warehouse-page.component.scss'],
})
export class WarehousePageComponent implements OnInit {
  images = IMAGE_GRID;

  constructor(
  ) {

  }

  ngOnInit(): void {

  }

  selectedImage: string | null = null;

  openImageOverlay(imageSrc: string) {
    this.selectedImage = imageSrc;
  }

  closeImageOverlay() {
    this.selectedImage = null;
  }

  onImageRightClick(event: MouseEvent) {
    event.preventDefault();

    // For example, log it or show a custom menu
    // console.log('Right-clicked image:'); 

  }
}
